<template>
  <div class="addAddress absolute" style="padding-top: 1rem">
    <!--<navTitle title="新增地址"></navTitle>-->
    <navTitle :title="
        $router.app._route.query.ti ? $router.app._route.query.ti : 'The new address'
      "></navTitle>

    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div class="name">Name</div>
        <input type="text" placeholder="Please enter name" v-model="userAddress.real_name" required />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">Phone</div>
        <input type="text" placeholder="please Masukkan nomor telepon Anda" v-model="userAddress.phone" required />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">Area</div>
        <div class="picker acea-row row-between-wrapper select-value form-control">
          <div class="address">
            <div slot="right" @click.stop="show2 = true">
              {{ model2 || "please select address" }}
            </div>
            <CitySelect v-model="show2" :callback="result2" :items="district" provance="" city="" area=""></CitySelect>
          </div>
          <div class="iconfont icon-dizhi font-color-red"></div>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">Detailed address</div>
        <input type="text" placeholder="Please fill in the specific address" v-model="userAddress.detail" required />
      </div>
    </div>
    <div class="default acea-row row-middle">
      <div class="select-btn">
        <div class="checkbox-wrapper">
          <label class="well-check"><input type="checkbox" name="" value="" @click="ChangeIsDefault"
              :checked="userAddress.is_default ? true : false" /><i class="icon"></i><span class="def">Set to the
              default address</span></label>
        </div>
      </div>
    </div>
    <div></div>
    <div class="keepBnt bg-color-red" @click="submit">Instantly save</div>
    <div class="wechatAddress" v-if="isWechat && !id" @click="getAddress">
      导入微信地址
    </div>
  </div>
</template>
<script type="text/babel">
  import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
  import navTitle from "@components/navTitle";

  import District from "ydui-district/dist/jd_province_city_area_id";
  import { getAddress, postAddress } from "@api/user";
  import attrs, { required, chs_phone } from "@utils/validate";
  import { validatorDefaultCatch } from "@utils/dialog";
  import { openAddress } from "@libs/wechat";
  import { isWeixin } from "@utils";

  export default {
    components: {
      CitySelect,
      navTitle
    },
    data() {
      return {
        show2: false,
        model2: "",
        district: District,
        id: 0,
        userAddress: { is_default: 0 },
        address: {},
        isWechat: isWeixin()
      };
    },
    mounted: function () {
      let id = this.$route.params.id;
      this.id = id;
      document.title = !id ? "添加地址" : "修改地址";
      this.getUserAddress();
    },
    methods: {
      getUserAddress: function () {
        if (!this.id) return false;
        let that = this;
        getAddress(that.id).then(res => {
          that.userAddress = res.data;
          that.model2 =
            res.data.province + " " + res.data.city + " " + res.data.district;
          that.address.province = res.data.province;
          that.address.city = res.data.city;
          that.address.district = res.data.district;
        });
      },
      getAddress() {
        openAddress().then(userInfo => {
          this.$dialog.loading.open();
          postAddress({
            id: this.id,
            real_name: userInfo.userName,
            phone: userInfo.telNumber,
            address: {
              province: userInfo.provinceName,
              city: userInfo.cityName,
              district: userInfo.countryName
            },
            detail: userInfo.detailInfo,
            is_default: 1,
            post_code: userInfo.postalCode
          })
            .then(() => {
              this.$dialog.loading.close();
              this.$dialog.toast({ mes: "Add a success" });
              this.$router.go(-1);
            })
            .catch(err => {
              this.$dialog.loading.close();
              this.$dialog.error(err.msg || "Add a failed");
            });
        });
      },
      async submit() {
        let name = this.userAddress.real_name,
          phone = this.userAddress.phone,
          model2 = this.model2,
          detail = this.userAddress.detail,
          isDefault = this.userAddress.is_default;
        try {
          await this.$validator({
            name: [
              required(required.message("Name")),
              attrs.range([2, 16], attrs.range.message("Name"))
            ],
            phone: [
              required(required.message("phone")),
              chs_phone(chs_phone.message())
            ],
            model2: [required("select addr")],
            detail: [required(required.message("addr detail"))]
          }).validate({ name, phone, model2, detail });
        } catch (e) {
          return validatorDefaultCatch(e);
        }
        try {
          let that = this,
            data = {
              id: that.id,
              real_name: name,
              phone: phone,
              address: this.address,
              detail: detail,
              is_default: isDefault,
              post_code: ""
            };
          postAddress(data).then(function () {
            if (that.id) that.$dialog.toast({ mes: "Modify the success" });
            else that.$dialog.toast({ mes: "Add a success" });
            that.$router.go(-1);
          });
        } catch (e) {
          this.$dialog.error(e.msg);
        }
      },
      ChangeIsDefault: function () {
        this.userAddress.is_default = !this.userAddress.is_default;
      },
      result2(ret) {
        this.model2 = ret.itemName1 + " " + ret.itemName2 + " " + ret.itemName3;
        this.address.province = ret.itemName1;
        this.address.city = ret.itemName2;
        this.address.district = ret.itemName3;
      }
    }
  };
</script>